export const RENDER_NORMAL = 'centerpane_100';
export const RENDER_FORM_EXPANDED = 'centerpane_rightpane_35_65';
